import React from "react";
import { Modal } from "react-bootstrap";
import { useForm} from "react-hook-form";
import { HrmFormInput } from "../components/hrm_input";
import { updateFaqValidation } from "../../validations/faq_validation";
import { useFaq } from "../../contexts/faq-context";
import { yupResolver } from "@hookform/resolvers/yup";

const FaqUpdate = ({ 
  onClose, 
  isFaqEditFormVisible, 
  initialValues = null
}) => {
    // const data = rowValues;
    const {
            handleSubmit,
            register,
            reset,
            formState: { errors } 
          } = useForm({ defaultValues: initialValues, resolver: yupResolver(updateFaqValidation) });
    
          const { onUpdateFaq, faqLoader } = useFaq();
        
          const onSubmit = async (values) => {
            const updatedValues = { ...values, faq_id: values.id };
            console?.log('updatedValues',updatedValues)
          // delete updatedValues.id;
            await onUpdateFaq(updatedValues);
              onClose();
          }

          const handleReset = () => {
            reset();
          }
    return (
        <Modal 
            show={isFaqEditFormVisible}
            onHide={onClose}
            size={"md"}
            className="custom-modal" 
            centered   
        >
        <Modal.Header>
          <Modal.Title className="text-center">
            <h5 className="text-xl font-semibold flex gap-2 items-center text-gray-800">
                Edit Faq
            </h5>
          </Modal.Title>
        </Modal.Header>    
            <Modal.Body className="space-y-4 p-6">
                <form onSubmit={handleSubmit(onSubmit)}>
                <HrmFormInput label={"Question"} error={errors?.question ? errors.question.message : ""} {...register("question")} />
                <HrmFormInput label={"Answer"} type="textarea" error={errors?.answer ? errors.answer.message : ""} {...register("answer")} />
                    <button type="submit" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">Update Faq</button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default FaqUpdate;